module.exports = __webpack_public_path__ + "static/media/antigua-historic-9.25205c9e.jpg";